import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";

Vue.use(Vuex);
export default {
  state: {},
  getters: {},
  actions: {
    addSlot({ commit, state }, { schedule }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        const schedulePath = `users/${state.user.uid}/lists/__schedule`;
        const scheduleRef = db.doc(schedulePath);
        return scheduleRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let schedule_name = Date.now();
              scheduleRef.update({
                _schedules: firebase.firestore.FieldValue.arrayUnion({
                  schedule_name: schedule_name,
                  _created_at: new Date()
                })
              });
            } else {
              return scheduleRef
                .set({
                  _schedules: {
                    schedule_name: Date.now(),
                    _created_at: new Date()
                  }
                })
                .then(() => {
                  console.log("successfully saved a schedule event");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in save schedule event: ", err);
            rej(err);
          });
      });
    }
  },
  mutations: {}
};
